module.exports = __webpack_public_path__ + "static/media/timer_play_inactive.b42d4819.svg";